import { routerPostCall } from '../../axios';

const getInvestmentTransactions = (state, params) => {
  const url = `/accounts/viewPortfolio/getHoldingTransactions`;
  return routerPostCall(state, url, params);
};
export default { getInvestmentTransactions };
